export default __webpack_public_path__ + "static/media/authentic-mono.34db2e55.svg";